/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-05.
 * Playground Container.
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TextField, FlatButton } from 'material-ui';
import * as actions from './actions';
import { RemoteDropDownSearch } from '../../components/data-containers';
import { test as testService } from '../../services';

class Playground extends Component {
    render() {
        return (
            <div>
                <TextField type="date" />
                <RemoteDropDownSearch
                    tooltip="Proveedor remoto"
                    label="Proveedor Remotito"
                    onChange={(selectedValue) => {
                        console.log(selectedValue);
                    }}
                    dataSourceConfig={{ text: 'name', value: 'id' }}
                    entity='customers'
                    serviceName='customers'
                    url='/customers/search/findTop10ByNameIgnoreCaseContaining'
                    projectionName='forListing'
                />
                <FlatButton
                    label="Make Secure Request"
                    onTouchTap={() => {
                        testService.getCustomers({
                            projection: 'denormalizedCustomer',
                            sort: 'name'
                        }).then(error => {
                            console.log(error);
                        });
                    }}
                />
            </div>
        );
    }
}

const mapStateToProps = ({ playground }) => {
    return { ...playground };
};

export default connect(mapStateToProps, { ...actions })(Playground);



// WEBPACK FOOTER //
// ./containers/playground/index.js